import { Event } from "@models/event";
import { CreditCard } from "@models/credit-card";

export class EventsStore {

  constructor(
    public events: Event[] = [],
    public activeEvent: Event = null,
    public editableCreditCard: CreditCard = null,
    public errors: any = null,
    public loading: boolean = false,
  ) {}

  static clone(store: EventsStore) {
    const result = new this()

    result.events = [...store.events]
    result.activeEvent = store.activeEvent
    result.editableCreditCard = store.editableCreditCard
    result.errors = store.errors

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/events.ts